import styled from 'styled-components';
import color from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const Ammount = styled.em`
	color: ${color.dark};
	font-family: 'Poppins', sans-serif;
	font-size: 28px;
	line-height: 42px;
	display: table;
	margin: 0 auto;
	text-align: center;
	font-style: normal;
	padding: 0 20px;
	position: relative;
	&:after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 4px;
		border-radius: 50px;
		background-color: ${color.redButtons};
	}
	@media screen and (max-width: ${ScreenSize.tablet}px) and (orientation: portrait) {
		padding: 0;
	}
`;

export const TitleContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const Data = styled.div`
	height: 100%;
`;

export const Error = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	> span {
		text-align: center;
	}
`;

export const Title = styled.span`
    color: ${color.dark};
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    line-height: 23px;
    margin-right: 9px;
`;

export const Icon = styled.i`
	cursor: help;
	> svg {
		height: 16px;
		width: 16px;
	}
`;
